var _path, _path2, _path3, _g, _path4, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 311.908h512v102.988a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.896V311.908z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 88.276h494.345a8.829 8.829 0 0 1 8.828 8.828v102.988H0V97.103a8.828 8.828 0 0 1 8.828-8.827z",
    fill: "#464655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8414b",
    d: "M0 200.09h512V311.9H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 194.21h512v17.655H0zM0 300.141h512v17.655H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.268 181.618c7.108-14.657 14.525-48.61 14.525-48.61s-22.072 26.845-29.182 41.501c-1.49 3.072-.858 6.605 1.294 8.995l-80.967 166.934 5.496 2.666 80.967-166.934c3.212.211 6.378-1.48 7.867-4.552z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.732 181.618c-7.108-14.657-14.525-48.61-14.525-48.61s22.072 26.845 29.182 41.501c1.49 3.072.858 6.605-1.294 8.995l80.967 166.934-5.496 2.666-80.967-166.934c-3.212.211-6.378-1.48-7.867-4.552z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.138 256c0 48.754-36.012 88.276-44.138 88.276S211.862 304.754 211.862 256s36.012-88.276 44.138-88.276 44.138 39.522 44.138 88.276z",
    fill: "#c8414b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#464655"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.31 298.591c5.199-12.631 8.828-27.14 8.828-42.591s-3.628-29.959-8.828-42.591c-5.199 12.631-8.828 27.14-8.828 42.591s3.629 29.96 8.828 42.591zM220.69 213.409c-5.199 12.631-8.828 27.14-8.828 42.591s3.628 29.959 8.828 42.591c5.199-12.631 8.828-27.14 8.828-42.591s-3.629-29.959-8.828-42.591z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 8.828,
    ry: 13.241
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.324 167.724v75.034c2.407-5.01 6.676-19.815 6.676-37.517 0-17.703-4.269-32.507-6.676-37.517zM254.676 167.724c-2.407 5.01-6.676 19.814-6.676 37.517s4.269 32.508 6.676 37.517v-75.034zM257.324 269.241v75.034c2.407-5.01 6.676-19.815 6.676-37.517 0-17.703-4.269-32.507-6.676-37.517zM254.676 269.241c-2.407 5.01-6.676 19.814-6.676 37.517s4.269 32.508 6.676 37.517v-75.034z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/ke.55a24201d376500fb001c6af63b1bb8c.svg";
export { ForwardRef as ReactComponent };